import { evaluateDynamicValue, Project } from 'lib'
import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectCtxEvaluationResultFactory } from 'store/selectors'

const useDynamicValueEvaluation = (
  dynamicValueRef: Project.GenericRef<Project.DynamicValue>,
): string => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [selector, setSelector] = useState<(state: any) => string | null>(
    () => () => '',
  )
  const ctxSelector = useMemo(
    () => selectCtxEvaluationResultFactory((_, context) => context),
    [],
  )
  const ctx = useSelector(ctxSelector)
  useEffect(() => {
    if (!ctx) {
      return
    }
    evaluateDynamicValue(dynamicValueRef, ctx).then((data) => {
      setSelector(() => selectCtxEvaluationResultFactory(() => data))
    })
  }, [ctx, dynamicValueRef])
  const result = useSelector(selector)
  return result || ''
}
export default useDynamicValueEvaluation
